import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { colors } from '../../styles/designSystem';
import { ArrowRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

const scenarios = [
  {
    title: 'useCaseScenarios.scenarios.missedCalls.title',
    before: 'useCaseScenarios.scenarios.missedCalls.before',
    after: 'useCaseScenarios.scenarios.missedCalls.after',
    icon: '📞', // You can replace with actual icons
  },
  {
    title: 'useCaseScenarios.scenarios.delayedResponses.title',
    before: 'useCaseScenarios.scenarios.delayedResponses.before',
    after: 'useCaseScenarios.scenarios.delayedResponses.after',
    icon: '⏰',
  },
  {
    title: 'useCaseScenarios.scenarios.techSkeptic.title',
    before: 'useCaseScenarios.scenarios.techSkeptic.before',
    after: 'useCaseScenarios.scenarios.techSkeptic.after',
    icon: '💡',
  },
];

const UseCaseScenarios = () => {
  const { t } = useTranslation();
  const [activeScenario, setActiveScenario] = useState(0);

  return (
    <section className="py-16 relative overflow-hidden">
   
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className={`${colors.text.heading} ${colors.primary.text} mb-6`}>
            {t('useCaseScenarios.title')}
          </h2>

        </div>

        {/* Interactive Scenarios Display */}
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Tabs Navigation */}
          <div className="lg:w-1/3">
            <div className="flex flex-col space-y-4">
              {scenarios.map((scenario, index) => (
                <button
                  key={index}
                  onClick={() => setActiveScenario(index)}
                  className={`p-4 rounded-lg text-left transition-all duration-300 ${
                    activeScenario === index
                      ? 'bg-violet-50 border-l-4 border-violet-500'
                      : 'hover:bg-gray-50'
                  }`}
                >
                  <div className="flex items-center space-x-3">
                    <span className="text-2xl">{scenario.icon}</span>
                    <span className="font-medium">{t(scenario.title)}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Content Display */}
          <div className="lg:w-2/3">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeScenario}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
                className="bg-white rounded-xl p-8 shadow-lg border border-gray-100"
              >
                <div className="space-y-6">
                  <div className="before-after-comparison">
                    <div className="mb-8">
                      <h3 className="text-lg font-semibold mb-2">
                        {t('useCaseScenarios.before')}
                      </h3>
                      <p className="text-gray-600">
                        {t(scenarios[activeScenario].before)}
                      </p>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold mb-2">
                        {t('useCaseScenarios.after')}
                      </h3>
                      <p className="text-gray-600">
                        {t(scenarios[activeScenario].after)}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCaseScenarios;
